import React, { useCallback, useEffect, useRef, useState } from 'react';
import { IoMdRefresh } from 'react-icons/io';

import { PiDotsThreeOutlineVerticalBold } from 'react-icons/pi';
import { TieredMenu } from 'primereact/tieredmenu';
import { getAxios, postAxios } from '../../axios/Axios';
import request from '../../request/request';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Loader from '../loader/Loader';
import { Button } from 'react-bootstrap';
import { Paginator } from 'primereact/paginator';
import { useNavigate } from 'react-router-dom';
import { formatNumberWithCommas, parseToHumanDate } from '../../utils/helper';
import moment from 'moment';
import PartyListingFilterDrawer from './PartyListingFilterDrawer';
import { useGlobal } from '../../context/GlobalContext';

const PartyListing = ({ user, changeToast }) => {
	const navigate = useNavigate();
	const {setDashboardTitle} = useGlobal();
	const [partyList, setPartyList] = useState();
	const [loading, setLoading] = useState(false);
	const [searchText, setSearchText] = useState('');
	const [searchPartyId, setSearchPartyId] = useState('');
	const [fromDate, setFromDate] = useState(null);
	const [toDate, setToDate] = useState(new Date());
	const [first, setFirst] = useState(0);
	const [rows, setRows] = useState(10);
	const [currentPage, setCurrentPage] = useState(1);
	const [partyType, setPartyType] = useState('');
	const [shouldFetch, setShouldFetch] = useState(false);
	const [filterDrawerVisible, setFilterDrawerVisible] = useState(false);


	const partyTypeItems = [
		{ name: 'All', value: 'ALL'},
		{ name: 'Person', value: 'PERSON' },
		{ name: 'Party Group', value: 'PARTY_GROUP' },
	];

	const formatDateParam = (value) => {
		if (!value) return undefined;
		const formatted = moment(value).format('YYYY-MM-DD');
		return formatted === 'Invalid date' ? undefined : formatted;
	};

	const fetchData = useCallback(async () => {
		try {
			setLoading(true);
			const params = {
				page: currentPage,
				rows,
			};

			if (searchText?.trim()) params.party_name = searchText.trim();
			if (partyType && partyType !== 'ALL') params.party_type = partyType;
			if (searchPartyId?.trim()) params.party_id = searchPartyId.trim();

			const fromDateParam = formatDateParam(fromDate);
			const toDateParam = formatDateParam(toDate);
			if (fromDateParam) params.from_date = fromDateParam;
			if (toDateParam) params.to_date = toDateParam;

			const response = await getAxios(`${request.getAllParty}`, {
				params,
			});

			if (response?.data.apiresponse?.type === 'OK') {
				setPartyList(response?.data);
			}

			setLoading(false);
		} catch (error) {
			console.log(error);
			setLoading(false);
		}
	}, [currentPage, rows, searchText, partyType, searchPartyId, fromDate, toDate]);


	const syncParty = useCallback(async (partyId) => {
		try {
			setLoading(true);
			const response = await postAxios(`${request.syncProductParty}`, {
				org_party_id: partyId,
			});
			if (response?.data.apiresponse?.type === 'OK') {
				changeToast({
					severity: 'success',
					summary: 'Success',
					detail: response?.data?.apiresponse?.message,
				});
				fetchData();
			} else {
				changeToast({
					severity: 'error',
					summary: 'Error',
					detail: response?.data?.apiresponse?.message,
				});
			}

			setLoading(false);
		} catch (error) {
			console.log(error);
			changeToast({
				severity: 'error',
				summary: 'Error',
				detail: error?.response?.data?.apiresponse?.message,
			});
		}
	}, []);


	useEffect(() => {
		fetchData();
	}, [first, currentPage, rows]);

	const handleSearch = useCallback(() => {
		setFilterDrawerVisible(false);
		fetchData();
	}, [fetchData]);

	const handleResetFilter = useCallback(async () => {
		setSearchText('');
		setPartyType('');
		setSearchPartyId('');
		setFromDate(null);
		setToDate(null);
		setFirst(0);
		setCurrentPage(1);
		setFilterDrawerVisible(false);
		setShouldFetch(true);
	}, []);

	useEffect(() => {
		if (shouldFetch) {
			fetchData();
			setShouldFetch(false);
		}
	}, [shouldFetch]);
	const onPageChange = (event) => {
		setFirst(event.first);
		setCurrentPage(event.page + 1);
		setRows(event.rows);
	};

	const renderCount = (rowData, { rowIndex }) => {
		const serialNumber = first + rowIndex + 1;
		return (
			<div className="flex justify-content-evenly gap-1">{serialNumber}</div>
		);
	};

	const renderpartyName = (rowData) => {
		return (
			<div className="d-flex flex-column">
				<div style={{ whiteSpace: 'nowrap' }}>
					{rowData?.party_name}
					
				</div>
				<div className="partyid-info">{rowData?.party_id}</div>
				<div className='d-flex gap-2'>
				<span
					className={`${rowData?.party_type_desc === 'Person' ? 'person-class' : 'party-group'}`}
				>
					{rowData?.party_type_desc} 
				</span>
				<a className='view-profile' href={`${process.env.REACT_APP_BABBUSIYA_PORTAL}/profile/${rowData?.party_name}/${rowData?.party_id}`} target='_blank'>
						<span title='View Profile'  > View Profile </span>
					</a>
				</div>
			</div>
		);
	};
	const renderSubscriptions = (rowData) => {
		return rowData?.product_subscriptions?.length > 0 ? (
			<ul className="mb-0 ps-0">
				{rowData.product_subscriptions.map((item, index) => (
					<li
						key={index}
						className="d-flex align-items-start justify-content-flex-start gap-1 "
					>
						<img
							src="/images/green_check_2.svg"
							alt="check"
							width={10}
							style={{ marginTop: '7px' }}
						/>
						<span style={{ color: '#0e870e' }}>{item?.subs_desc}</span>
					</li>
				))}
			</ul>
		) : (
			<li className="d-flex align-items-center justify-content-flex-start gap-1">
				<img
					src="/images/cross.svg"
					alt="cross"
					width={10}
					style={{ margin: '3px' }}
				/>
				<span style={{ color: '#9b4c4c' }}>No Subscriptions</span>
			</li>
		);
	};

	const renderLastSyncedOn = (rowData) => {
		return (
			<div className="webiste-detail-container ">
				<span style={{ whiteSpace: 'nowrap' }} >{rowData?.global_search_sync_dt ? parseToHumanDate(rowData?.global_search_sync_dt).date : '-'}</span><br/>
				<span className='text-muted' style={{ fontSize: '12px' }} >{rowData?.global_search_sync_dt ? parseToHumanDate(rowData?.global_search_sync_dt, { timeOptions: { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true }}).time : '-'}</span><br/>
				<span className='text-muted party-group' style={{ fontSize: '12px' }} >{rowData?.global_search_sync_dt ? parseToHumanDate(rowData?.global_search_sync_dt).relative : '-'}</span><br/>
			</div>
		);
	};

	const renderRegisteredDate = (rowData) => {
		return (
			<div className="webiste-detail-container ">
				<span style={{ whiteSpace: 'nowrap' }} >{rowData?.created_stamp ? parseToHumanDate(rowData?.created_stamp).date : '-'}</span><br/>
				<span className='text-muted' style={{ fontSize: '12px' }} >{rowData?.created_stamp ? parseToHumanDate(rowData?.created_stamp, { timeOptions: { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true }}).time : '-'}</span><br/>
				<span className='text-muted party-group' style={{ fontSize: '12px' }} >{rowData?.created_stamp ? parseToHumanDate(rowData?.created_stamp).relative : '-'}</span><br/>
			</div>
		);
	};

	const renderIcon = (rowData) => {
		return rowData?.profile_pic ? (
			<div className="d-flex justify-content-center">
				<img src={rowData?.profile_pic} alt="Category Icon" height={50} />
			</div>
		) : (
			<div className="d-flex justify-content-center">
				<img src="/images/no-icon.webp" alt="Category Icon" height={50} />
			</div>
		);
	};
	const renderActions = (rowData) => {
		const menu = useRef(null);
		const items = [
			{
				label: 'Sync Party',
				icon: 'pi pi-sync',
				command: async () => {
					await syncParty(rowData?.party_id);
					fetchData();
				},
			},
			{
				label: 'Edit Party',
				icon: 'pi pi-file-edit'
			},
			{
				label: 'Create Party Advertisement',
				icon: 'pi pi-plus-circle',
				command: () => {
					navigate(`/create-party-advertisment?id=${rowData?.party_id}`, {
						state: rowData?.party_id,
					});
				},
			},
			...(user.privileges?.ORDERMGR_SALES_ENTRY === 1
				? [
						{
							label: 'Grant a Product Subscription',
							icon: 'pi pi-check-circle',
							command: () => {
								navigate(
									`/grant-product-subscription?id=${rowData?.party_id}`,
									{
										state: rowData?.party_id,
									}
								);
							},
						},
					]
				: []),
		];
		return (
			<div className=" cursor-pointer flex justify-content-center">
				<TieredMenu model={items} popup ref={menu} breakpoint="767px" />
				<span
					className="global-category-action"
					icon="pi pi-check"
					aria-label="Filter"
					label="Show"
					onClick={(e) => menu.current.toggle(e)}
				>
					<PiDotsThreeOutlineVerticalBold />
				</span>
			</div>
		);
	};


    useEffect(()=> {
        setDashboardTitle('Party Listing');
    }, [])

	return (
		<div>
			{loading && <Loader />}
			<div className="global-category-heading d-flex justify-content-between flex-column ">
				<div className="breadcrumbs">Data/ Party Listing</div>
			</div>

			<div className="m-2 d-flex gap-2 justify-content-between align-items-center  w-100">
				<div className="pr-3">
					<span className="font-bold ">Total Records:</span>
					<span> {partyList?.metadata?.total ? formatNumberWithCommas(partyList?.metadata?.total) : 0} </span>
				</div>
				<div
					style={{ width: '75%' }}
					className="d-flex gap-2 flex-row  justify-content-end align-items-center  prime-react-btn"
				>
					<Button
						variant="outline-secondary"
						disabled={loading}
						onClick={() => setFilterDrawerVisible(true)}
						title='filter'
					>
						<i className="pi pi-filter" />
					</Button>
					<button
						className="btn submit-btn text-white"
						disabled={loading}
						onClick={!loading ? fetchData : null}
						title='refresh'
					>
						<IoMdRefresh size="1.3em" />
					</button>
				</div>
			</div>

		
			<DataTable value={partyList?.records} showGridlines>
				<Column body={renderCount} header="S.No" />
				<Column body={renderIcon} header="Profile Pic" />

				<Column body={renderpartyName} header="Party Name" />
				<Column field="address" header="Address" />
				<Column body={renderSubscriptions} header="Subscriptions" />
				<Column field="contact_number" header="Contact Number" />
				<Column body={renderRegisteredDate} header={"Registered Date"} />
				<Column body={renderLastSyncedOn} header="Last Synced On" />

				{partyType === 'PARTY_GROUP' && (
					<Column body={renderActions} header="Action" />
				)}
			</DataTable>

			<Paginator
				first={first}
				rows={rows}
				totalRecords={partyList?.metadata?.total}
				rowsPerPageOptions={[10, 20, 50, 100]}
				onPageChange={onPageChange}
			/>

			<PartyListingFilterDrawer
				filterDrawerVisible={filterDrawerVisible}
				setFilterDrawerVisible={setFilterDrawerVisible}
				partyType={partyType}
				setPartyType={setPartyType}
				partyTypeItems={partyTypeItems}
				searchText={searchText}
				setSearchText={setSearchText}
				searchPartyId={searchPartyId}
				setSearchPartyId={setSearchPartyId}
				fromDate={fromDate}
				setFromDate={setFromDate}
				toDate={toDate}
				setToDate={setToDate}
				loading={loading}
				handleResetFilter={handleResetFilter}
				handleSearch={handleSearch}
			/>
		</div>
	);
};

export default PartyListing;
